import { createAction } from '@poa/state';

// fetching
export const fetch = createAction('calendar/fetchCalendar', (fetchType) => ({ fetchType }));
export const fetchSuccess = createAction('calendar/fetchSuccess', data => ({ data }));
export const fetchFailed = createAction('calendar/fetchFailed', () => ({}));
export const fetchExpandableSuccess = createAction('calendar/fetchExpandableSuccess', data => ({ data }));


export const setDates = createAction('setDates', (
  { startDate, endDate, shouldFetch = true }) => ({
  startDate,
  endDate,
  shouldFetch
}));
